/* eslint import/no-extraneous-dependencies: 0 */

import 'bootstrap';

import Contact from 'app/models/contact';
import Base from 'app/views/base';

import { showSuccess, getResponseErrors } from 'utils/messages';
import { clearPopoversOnView, displayErrorsOnView, displayErrorOnField } from 'utils/forms';

import tmpl from 'templates/talk_to_easypost';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'submit #contact_form': 'submit',
    'keyup input': 'clearPopover',
  },

  initialize() {
    this.model = new Contact({});
    this.formSubmitted = false;
  },

  afterRender() {
    this.setFocus('name');
  },

  context() {
    return {
      formSubmitted: this.formSubmitted,
      name: this.model.get('name') || '',
      company_name: this.model.get('company_name') || '',
      email: this.model.get('email') || '',
      phone_number: this.model.get('phone_number') || '',
      question: this.model.get('question') || '',
    };
  },

  submit(e) {
    const self = this;
    e.preventDefault();
    this.formSubmitted = true;

    this.model.save({
      name: this.$('input#contact-name').val(),
      company_name: this.$('input#contact-company_name').val(),
      email: this.$('input#contact-email').val(),
      phone_number: this.$('input#contact-phone_number').val(),
      question: this.$('textarea#contact-question').val(),
    }, {
      success() {
        clearPopoversOnView(self);
        showSuccess('Your question has been submitted, we\'ll contact you soon!');
      },
      error(model, response) {
        clearPopoversOnView(self);
        self.formSubmitted = false;
        self.render();

        const errors = getResponseErrors(response);
        displayErrorsOnView(self, errors, ['name', 'company_name', 'email', 'phone_number', 'question']);
      },
    });
    this.render();
  },

  setFocus(attribute) {
    this.$(`#contact-${attribute}`).focus();
  },

  displayError(attribute, message) {
    const formField = this.$(`#contact-${attribute}`);
    displayErrorOnField(formField, message);
  },

  clearPopover(e) {
    $(e.currentTarget).popover('hide');
  },
});



// WEBPACK FOOTER //
// ./app/views/talk_to_easypost_page.js